import { RichText } from '@ads-core/components';

type PreAnnouncementTextProps = {
  mainText: string | null | undefined;
  announcementTexts: string[] | null | undefined;
};

export const PreAnnouncementText = ({ mainText, announcementTexts }: PreAnnouncementTextProps) => {
  if ((!mainText && !announcementTexts) || !announcementTexts?.length) return null;

  return (
    <>
      {mainText ? <RichText>{mainText}</RichText> : null}
      {announcementTexts.map((preAnnouncement, index) => (
        <RichText key={`pre-announcement-${index}`}>{`<p>${preAnnouncement}</p>`}</RichText>
      ))}
    </>
  );
};
